/* Gift Set Promo — optional reveal-on-scroll + gentle parallax.
   Progressive enhancement: without JS the section is fully visible (reveal
   styles are gated behind .gsbp--js). The section CSS/JS are linked assets,
   so this file can be injected once per section instance — it guards itself
   with a window singleton so listeners/observers bind only once page-wide,
   and is idempotent per element (data-gsbp-ready). */
(function () {
  'use strict';
  if (window.GiftSetPromo) { window.GiftSetPromo.init(document); return; }

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var parallaxEls = [];
  var ticking = false;
  var listenersBound = false;

  function setupReveals(scope) {
    var reveals = Array.prototype.slice.call(scope.querySelectorAll('.gsbp__reveal'));
    if (!reveals.length) return;
    var show = function (el) { el.classList.add('in'); };
    if (REDUCE || !('IntersectionObserver' in window)) { reveals.forEach(show); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); obs.unobserve(e.target); } });
    }, { threshold: 0.14 });
    var vh = window.innerHeight || document.documentElement.clientHeight;
    reveals.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) { show(el); } else { io.observe(el); }
    });
    setTimeout(function () { reveals.forEach(show); }, 1800);
  }

  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      var mobile = window.innerWidth < 900;
      parallaxEls.forEach(function (el) {
        if (mobile) { el.style.transform = ''; return; }
        var host = el.closest('[data-gsbp-parallax]'); if (!host) return;
        var r = host.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translateY(' + (progress * -22) + 'px)';
      });
      ticking = false;
    });
  }

  function collectParallax(scope) {
    if (REDUCE) return;
    Array.prototype.slice.call(scope.querySelectorAll('[data-gsbp-parallax] .gsbp__media-inner')).forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
    if (parallaxEls.length && !listenersBound) {
      listenersBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    if (parallaxEls.length) onScroll();
  }

  function init(scope) {
    var root = scope || document;
    Array.prototype.slice.call(root.querySelectorAll('.gsbp')).forEach(function (el) {
      if (el.getAttribute('data-gsbp-ready') === '1') return;
      el.setAttribute('data-gsbp-ready', '1');
      el.classList.add('gsbp--js');
    });
    setupReveals(root);
    collectParallax(root);
  }

  window.GiftSetPromo = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
  document.addEventListener('shopify:section:unload', function () {
    parallaxEls = parallaxEls.filter(function (el) { return el.isConnected; });
    if (!parallaxEls.length && listenersBound) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      listenersBound = false;
    }
  });
})();
